import { NavigationRoutes } from 'common/constants';
import { themedStyled } from 'common/styles/styletron.theme';
import HOCInput from 'components/common/hoc-input';
import Separator from 'components/common/separator';
import { Input } from 'components/elements';
import { Button } from 'components/elements/buttons';
import Text from 'components/elements/text';
import useNavigation from 'hooks/use-navigation';
import {
  CardSection,
  FullContainer,
  HalfContainer,
  SectionContainer as RawSectionContainer,
} from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';

export default function TourCardDetail() {
  const { t } = useTranslation();
  const { navigate } = useNavigation();

  return (
    <CardSection style={{ paddingBottom: 0 }}>
      <SectionContainer>
        <Text variant="HeadingXSmall">
          {t('common:detail_extra', { extra: t('common:tour') })}
        </Text>
        <HOCInput keys={['approvalable']}>
          {(value) => (
            <Button
              buttonType="secondary"
              onClick={() =>
                navigate(NavigationRoutes.TourView, {
                  id: value.approvalable.id,
                })
              }
            >
              {t('common:view_old_data')}
            </Button>
          )}
        </HOCInput>
      </SectionContainer>
      <Separator gap={16} />
      <SectionContainer>
        <HalfContainer>
          <Input
            type="text"
            name="approvalable.code"
            label={t('common:code')}
            placeholder={t('common:code')}
          />
        </HalfContainer>
        <HalfContainer>
          <Input
            type="date-time"
            name="approvalable.transactionAt"
            label={t('common:transaction_at')}
            placeholder={t('common:transaction_at')}
          />
        </HalfContainer>
      </SectionContainer>
      <HalfContainer>
        <Input
          type="text"
          name="approvalable.name"
          label={t('common:tour_name')}
          placeholder={t('common:tour_name')}
          required
        />
      </HalfContainer>
      <FullContainer>
        <Input
          type="text-area"
          name="approvalable.description"
          label={t('common:description')}
          placeholder={t('common:description')}
        />
      </FullContainer>
      <SectionContainer>
        <HalfContainer>
          <SectionContainer>
            <HalfContainer>
              <Input
                type="date-time"
                name="approvalable.startedAt"
                label={t('common:from')}
                placeholder={t('common:from')}
                required
              />
            </HalfContainer>
            <HalfContainer>
              <Input
                type="date-time"
                name="approvalable.endedAt"
                label={t('common:to')}
                placeholder={t('common:to')}
                required
              />
            </HalfContainer>
          </SectionContainer>
        </HalfContainer>
        <HalfContainer>
          <SectionContainer>
            <HalfContainer style={style.duration}>
              <FullContainer style={style.contentFlex}>
                <Input
                  type="number"
                  name="approvalable.day"
                  required
                  label={t('common:duration')}
                />
              </FullContainer>
              <Text variant="LabelSmall" $style={durationTextStyle}>
                {t('common:days')}
              </Text>
            </HalfContainer>
            <HalfContainer style={style.duration}>
              <FullContainer style={style.contentFlex}>
                <Input
                  type="number"
                  name="approvalable.night"
                  required
                  label={t('common:night')}
                />
              </FullContainer>
              <Text variant="LabelSmall" $style={durationTextStyle}>
                {t('common:night')}
              </Text>
            </HalfContainer>
          </SectionContainer>
        </HalfContainer>
      </SectionContainer>
    </CardSection>
  );
}

const SectionContainer = themedStyled(RawSectionContainer, {
  width: '100%',
});

const style: { [key: string]: React.CSSProperties } = {
  duration: {
    display: 'flex',
    alignItems: 'end',
  },
  contentFlex: {
    width: 'auto',
    flex: 1,
    display: 'flex',
  },
};

const durationTextStyle = {
  height: '30px',
  marginBottom: '16px',
  display: 'flex',
  alignItems: 'center',
  marginLeft: '8px',
  justifyContent: 'end',
  flexBasis: '44px',
};
